var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{attrs:{"md":"6"}},[_c('button',{class:[
      'menu-card',
      'mb-4',
      { 'menu-card--shadowed': _vm.hasShadow, 'menu-card--with-hover-effect': _vm.hasHoverEffect },
    ],on:{"click":function($event){return _vm.$emit('click')}}},[_c('p',{staticClass:"menu-card__title"},[_vm._v(_vm._s(_vm.$t(_vm.title)))]),_c('p',{staticClass:"menu-card__description mb-0"},[_vm._v(_vm._s(_vm.$t(_vm.description)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }